import { gql, QueryHookOptions, QueryResult, useQuery } from '@apollo/client';

import { publicGraphQLURL } from '../../../../config';
import { IGetInstitutionCustomTexts } from '../../institutions/useGetInstitutionCustomTexts';

export const GET_GLOBAL_CUSTOM_TEXTS = gql`
  query GetGlobalCustomTexts($languageId: LanguageId!) {
    getGlobalCustomTexts(languageId: $languageId) {
      textKey
      languageId
      textValue
    }
  }
`;

export interface IGetGlobalCustomTextsParams {
  languageId: string;
}

export interface IGetGlobalCustomTextsResponse {
  getGlobalCustomTexts: IGetInstitutionCustomTexts[];
}

export const useQueryGetGlobalCustomTexts = (
  { languageId }: IGetGlobalCustomTextsParams,
  options?: QueryHookOptions<IGetGlobalCustomTextsResponse, IGetGlobalCustomTextsParams>,
): QueryResult<IGetGlobalCustomTextsResponse, IGetGlobalCustomTextsParams> =>
  useQuery<IGetGlobalCustomTextsResponse, IGetGlobalCustomTextsParams>(GET_GLOBAL_CUSTOM_TEXTS, {
    variables: { languageId },
    context: { uri: publicGraphQLURL },
    ...options,
  });
